class ApiGroups {
    constructor(Restangular, ApiBaseResponseService) {
        return {

            getInfo(token) {
                return Restangular.all('groups/invite')
                                  .get('info',{'token' : token })
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            acceptInvite(token, userExists) {
                return Restangular.all('groups/invite/accept')
                                  .post(null, {'token': token, 'userExists': userExists})
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            declineInvite(token) {
                 return Restangular.all('groups/invite/decline')
                                  .post(null, {'token': token })
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            }

        };
    }
}

ApiGroups.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiGroups;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiGroups.js
 **/